import React from "react";

const SaveBanner = ({ showNotification, saveStatus }) => {
  if (!showNotification) return null;

  return (
    <div className={`save-notification ${saveStatus.includes("Failed") ? "error" : ""}`}>
      {saveStatus}
    </div>
  );
};

export default SaveBanner;
